export * from './rel';
export * from './callNewApp';
export * from './h5PageCount';
export * from './transform';
export * from './handleAd';
export * from './handleTjLink';
export * from './callVideoApp';
export * from './linkedMeVideoApp';
export * from './createUid';
export * from './handleStick';
export * from './handlePageBack';
export * from './classnames';
export * from './wxShareTool';
